import { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ResponsiveOverlay } from '@/components/ui/ResponsiveOverlay';
import { ACTIVITY_TYPE_META } from '@/lib/activities/activityTypeMeta';

function buildActivityActions(basePath: string) {
  const em = ACTIVITY_TYPE_META.find(t => t.value === 'event')!;
  return [
    { label: 'Ny aktivitet', description: em.description, icon: em.icon, href: `${basePath}/events/new?type=event`, type: 'event' },
  ];
}

interface UseCreateActivitySheetResult {
  open: boolean;
  openCreateMenu: () => void;
  CreateActivitySheet: React.FC;
}

export function useCreateActivitySheet(farmId: string): UseCreateActivitySheetResult {
  const [open, setOpen] = useState(false);
  const openCreateMenu = useCallback(() => setOpen(true), []);

  const basePath = `/app/producer/farm/${farmId}`;
  const actions = buildActivityActions(basePath);

  const CreateActivitySheet: React.FC = () => (
    <ResponsiveOverlay
      open={open}
      onOpenChange={setOpen}
      title="Skapa aktivitet"
      showHeader
    >
      <p className="text-sm text-muted-foreground mb-4">Välj vilken typ av aktivitet du vill skapa.</p>
      <div className="grid gap-2 py-4">
        {actions.map((action) => (
          <Button
            key={action.label}
            variant="ghost"
            className="justify-start gap-3 h-auto py-3 text-base"
            data-testid={`create-activity-option-${action.type}`}
            asChild
            onClick={() => setOpen(false)}
          >
            <Link to={action.href}>
              <action.icon className="h-5 w-5 shrink-0" />
              <div className="text-left">
                <span className="block">{action.label}</span>
                <span className="block text-sm font-normal text-muted-foreground">{action.description}</span>
              </div>
            </Link>
          </Button>
        ))}
      </div>
    </ResponsiveOverlay>
  );

  return { open, openCreateMenu, CreateActivitySheet };
}
